import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';

const BetaStatusTag = ({ betaStatus, betaRequestTimestamp, shouldShowBetaStatus, showDropdown, setShowDropdown, dropdownCoords, betaButtonRef }) => {
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    if (betaStatus !== 'approved') return;

    const expiry = new Date(new Date(betaRequestTimestamp).getTime() + 24 * 60 * 60 * 1000);

    const interval = setInterval(() => {
      const now = new Date();
      const diffMs = expiry - now;

      if (diffMs <= 0) {
        clearInterval(interval);
        setCountdown('EXPIRED'); // could hide or replace with prompt
      } else {
        const hrs = Math.floor(diffMs / (1000 * 60 * 60));
        const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diffMs % (1000 * 60)) / 1000);
        setCountdown(`${hrs}h ${mins}m ${secs}s`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [betaStatus]);

  const statusColorMap = {
    pending: 'text-cowjuice-gold',
    approved: 'text-cowjuice-bronze',
    rejected: 'text-cowjuice-red',
    };

  if (!shouldShowBetaStatus) return null;

  // CASE 1: No status — new user
  if (betaStatus === null) {
    return (
      <button
        className="text-black font-mono animate-pulse uppercase text-[10px] border-[0.5px] border-black px-2 rounded-md bg-cowjuice-gold/10"
        onClick={() => navigate('/shopify/products')}
      >
        <p className="text-black opacity-60">Join the Private Beta →</p>
      </button>
    );
  }

  // CASE 2–4: Pending, Approved, Rejected
  return (
    <>
      <button
        className="text-black font-mono animate-pulse uppercase text-[10px] border-[0.5px] border-black px-2 rounded-md bg-cowjuice-gold/10"
        onClick={() => setShowDropdown(!showDropdown)}
        ref={betaButtonRef}
      >
        <p className="text-black">
            <span class=" opacity-60">Beta Access:{' '}</span>
            <span className={`${statusColorMap[betaStatus] || 'text-black'} font-bold`}>
                {betaStatus}
            </span>
        </p>

      </button>

      {showDropdown &&
        ReactDOM.createPortal(
          <div
            className="absolute z-[25] max-w-xs"
            style={{
              top: `${dropdownCoords.top}px`,
              left: `${dropdownCoords.left}px`,
              position: 'absolute',
            }}
          >
            <div className="bg-white border-[0.5px] border-black rounded-md p-2 animate-flip-down">
              {betaStatus === 'approved' && (
                <>
                  <p className="text-[10px] leading-3 font-mono text-black uppercase">
                    <span className="text-black">
                      <span class="opacity-60">You have been granted access to the{' '}</span>
                      <span className="text-cowjuice-gold border-[0.5px] border-cowjuice-gold rounded-sm px-[2px]">
                        Cow Juice Private Beta Testing Program
                      </span>.
                    </span>
                  </p>
                  {countdown && countdown !== 'EXPIRED' && (
                    <p className="text-[10px] leading-3 font-mono text-black uppercase mt-2">
                      <span class="opacity-60">You have </span> <span class="font-bold text-cowjuice-bronze animate-pulse">{countdown}</span> <span class="opacity-60">left to purchase before losing access.</span>
                    </p>
                  )}
                  
                  <button
                    onClick={() => navigate('/shopify/products')}
                    className="mt-2 w-full text-black font-mono text-[10px] border-[0.5px] border-black px-2 py-2 uppercase rounded-lg bg-white"
                  >
                    Buy Cow Juice Before the Herd →
                  </button>
                </>
              )}

              {betaStatus === 'pending' && (
                <p className="text-[10px] leading-3 font-mono text-black opacity-60 uppercase ">
                  Your request is being reviewed. Please check back soon.
                </p>
              )}

              {betaStatus === 'rejected' && (
                <p className="text-[10px] leading-3 font-mono text-black opacity-60">
                  You were not selected for the beta. If this is an error, email us.
                </p>
              )}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default BetaStatusTag;